import { ShopkeeperUpdateCheckResponse } from './../../models/shopkeeper/shopkeeper-update-chek-response.type';
import { LoginStorage } from './../../../login/login.storage';
import { ShopkeeperService } from './../../../services/shopkeeper/shopkeeper.service';
import { FichaService } from './../../../ficha-veiculo/ficha-veiculo.service';
import {
  Component,
  OnInit,
  DoCheck,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { customEmailValidator } from '../../validators/custom-email-validator/custom-email-validator';
import { finalize, take } from 'rxjs/operators';
import { ShopkeeperUpdateBody } from '../../models/shopkeeper/shopkeeper-update-body.type';
import * as toastr from 'toastr';
import { onlyDigits } from '../../helper/utils';

@Component({
  selector: 'app-update-shopkeeper-form',
  templateUrl: './update-shopkeeper-form.component.html',
  styleUrls: ['./update-shopkeeper-form.component.scss'],
})
export class UpdateShopkeeperFormComponent implements OnInit, DoCheck {
  @Input() opened: boolean = false;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  public formGroup: FormGroup;
  public errorMessageCelphone: string = null;
  public errorMessageEmail: string = null;
  public loadingCelphone = false;
  public loadingEmail = false;
  public shopkeeperInfo: ShopkeeperUpdateCheckResponse;
  private setted: boolean = false;
  public loadingSave: boolean = false;
  public success: boolean = false;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly fichaService: FichaService,
    private readonly shopkeeperService: ShopkeeperService,
    private readonly loginStorage: LoginStorage
  ) {}

  ngOnInit() {
    this.formGroup = this.initilizeForm();
  }

  ngDoCheck(): void {
    if (this.loginStorage.shopkeeperInfo && !this.setted && this.opened) {
      this.setted = true;
      this.shopkeeperInfo = this.loginStorage.shopkeeperInfo;
      this.formGroup.patchValue({
        phone:
          this.shopkeeperInfo.merchant.ddd + this.shopkeeperInfo.merchant.phone,
        email: this.shopkeeperInfo.merchant.email,
      });

      this.formGroup.updateValueAndValidity();
      this.phone.markAllAsTouched();
      this.email.markAllAsTouched();
    }
  }

  initilizeForm(): FormGroup {
    return this.formBuilder.group({
      phone: this.formBuilder.control('', {
        validators: [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(15),
        ],
        asyncValidators: [this.validCelphone()],
        updateOn: 'blur',
      }),
      email: this.formBuilder.control('', {
        validators: [Validators.required, customEmailValidator()],
        asyncValidators: [this.validEmail()],
        updateOn: 'blur',
      }),
    });
  }

  get email(): AbstractControl {
    return this.formGroup.get('email');
  }

  get phone(): AbstractControl {
    return this.formGroup.get('phone');
  }

  getDddAndCelular(value): { ddd: string; telefone: string } {
    if (!value || value === '') return { ddd: '', telefone: '' };
    const digits = onlyDigits(value);
    const ddd = digits.substring(0, 2);
    const telefone = digits.substring(2);
    return { ddd, telefone };
  }

  validCelphone(): AsyncValidatorFn {
    this.loadingCelphone = true;
    this.errorMessageCelphone = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      const dddCelular = this.getDddAndCelular(control.value);
      return this.fichaService
        .verifyCellPhone(dddCelular.ddd, dddCelular.telefone, false)
        .pipe(
          take(1),
          finalize(() => (this.loadingCelphone = false))
        )
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessageCelphone = null;
            return null;
          }
          this.errorMessageCelphone = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  clearErrorMessageCelphone() {
    this.errorMessageCelphone = null;
  }

  validEmail(): AsyncValidatorFn {
    this.loadingEmail = true;
    this.errorMessageEmail = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      return this.fichaService
        .verifyEmail(control.value, false)
        .pipe(
          take(1),
          finalize(() => (this.loadingEmail = false))
        )
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessageEmail = null;
            return null;
          }
          this.errorMessageEmail = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  clearErrorMessageEmail() {
    this.errorMessageEmail = null;
  }

  updateShopkeeper() {
    if (this.formGroup.invalid) {
      return;
    }
    this.loadingSave = true;
    const body: ShopkeeperUpdateBody = {
      ddd: this.getDddAndCelular(this.phone.value).ddd,
      phone: this.getDddAndCelular(this.phone.value).telefone,
      email: this.email.value,
      id: this.shopkeeperInfo.merchant.id,
    };
    this.shopkeeperService
      .updateShopkepper(String(this.shopkeeperInfo.merchant.id), body)
      .pipe(
        take(1),
        finalize(() => (this.loadingSave = false))
      )
      .subscribe((res) => {
        if (res.status === 'FAIL') {
          toastr.error(res.messages[0]);
          return;
        }
        this.success = true;
      });
  }
}
